export default __webpack_public_path__ + "static/media/RecycleBinFull.09154536.svg";